import {Component, Input, OnInit} from '@angular/core';
import {EstoqueService} from "../../services/estoque.service";
import {UnidadeMedidaUtils} from "../UnidadeMedidaUtils";

@Component({
  selector: 'app-tela-historico-movimentacoes',
  templateUrl: './tela-historico-movimentacoes.component.html',
  styleUrls: ['./tela-historico-movimentacoes.component.scss']
})
export class TelaHistoricoMovimentacoesComponent implements OnInit {
  @Input() insumo: any = {}
  @Input() produto: any = {}
  @Input() exibirInsumo = false;
  carregando: boolean;
  movimentacoes = [];
  exibeDadosFinanceiros = false;
  paginacao = {
    size: 5,
    skip: 0,
    total: 0,
    buttonCount: 5,
    info: true,
    type: "numeric",
    pageSizes: false,
    previousNext: true
  };
  gridData: any  = {}
  filtro: any  = { inicio:  null, fim:  null}
  detalheBeneficiamento: any;
  carregandoBeneficiamento = false;
  confirmandoEstornoBeneficiamento = false;
  estornandoBeneficiamento = false;
  justificativaEstornoBeneficiamento: string;
  erroBeneficiamento: string;
  constructor(private estoqueService: EstoqueService) { }

  ngOnInit(): void {
    setTimeout(async () => {
      await this.carregueMovimentacoes();
    }, 0)
  }

  async carregueMovimentacoes(inicio = 0, termo: string = null, grupo: any = null){
    this.carregando = true;
    let resposta: any;
    if(this.insumo.id){
      resposta = await this.estoqueService.listeMovimentacoesInsumo(
        this.insumo,
        inicio,
        this.paginacao.size,
        this.filtro
      );
    } else if (this.produto.id) {
      resposta = await this.estoqueService.listeMovimentacoesProduto(
        this.produto,
        inicio,
        this.paginacao.size,
        this.filtro
      );
    } else {
      this.paginacao.size = 20;
      resposta =  await this.estoqueService.listeMovimentacoes(inicio,  this.paginacao.size, this.filtro.inicio, this.filtro.fim ,
        termo, grupo)
    }

    if(resposta){
      this.exibeDadosFinanceiros = (resposta.movimentacoes || [])
        .some((movimentacao: any) => this.possuiFotografiaFinanceira(movimentacao));
      this.gridData = {
        data: resposta.movimentacoes,  // Dados da página atual
        total: resposta.total  // Total de itens
      };
    }

    this.carregando = false;
  }

  public mudouPaginacao(event: any): void {
    this.paginacao.skip = event.skip;
    this.paginacao.size = event.take;
    setTimeout(async () => {
      await this.carregueMovimentacoes(  this.paginacao.skip);
    }, 0)

  }

  obtenhaDescricaoUnidade( movimentacao: any){
    return UnidadeMedidaUtils.obtenhaDescricaoUnidade(movimentacao)
  }

  apliqueFiltro(): void {
    this.paginacao.skip = 0;
    this.carregueMovimentacoes(0);
  }

  possuiFotografiaFinanceira(movimentacao: any): boolean {
    return !!movimentacao.processadoEm;
  }

  async abraBeneficiamento(beneficiamento: any): Promise<void> {
    if(!beneficiamento || !beneficiamento.id || this.carregandoBeneficiamento)
      return;
    this.carregandoBeneficiamento = true;
    this.erroBeneficiamento = null;
    try {
      this.detalheBeneficiamento = await this.estoqueService
        .obtenhaBeneficiamento(Number(beneficiamento.id));
    } catch(erro) {
      this.erroBeneficiamento = this.textoErro(erro);
    } finally {
      this.carregandoBeneficiamento = false;
    }
  }

  fecheBeneficiamento(): void {
    if(this.estornandoBeneficiamento)
      return;
    this.detalheBeneficiamento = null;
    this.confirmandoEstornoBeneficiamento = false;
    this.justificativaEstornoBeneficiamento = null;
    this.erroBeneficiamento = null;
  }

  prepareEstornoBeneficiamento(): void {
    this.confirmandoEstornoBeneficiamento = true;
    this.erroBeneficiamento = null;
  }

  canceleEstornoBeneficiamento(): void {
    this.confirmandoEstornoBeneficiamento = false;
    this.justificativaEstornoBeneficiamento = null;
    this.erroBeneficiamento = null;
  }

  async estorneBeneficiamento(): Promise<void> {
    if(!this.detalheBeneficiamento || !this.detalheBeneficiamento.podeEstornar ||
       this.estornandoBeneficiamento)
      return;
    if(!this.justificativaEstornoBeneficiamento || !this.justificativaEstornoBeneficiamento.trim()){
      this.erroBeneficiamento = 'Informe a justificativa do estorno.';
      return;
    }
    this.estornandoBeneficiamento = true;
    this.erroBeneficiamento = null;
    try {
      this.detalheBeneficiamento = await this.estoqueService.estorneBeneficiamento(
        Number(this.detalheBeneficiamento.id),
        this.justificativaEstornoBeneficiamento.trim()
      );
      this.confirmandoEstornoBeneficiamento = false;
      this.justificativaEstornoBeneficiamento = null;
      await this.carregueMovimentacoes(this.paginacao.skip);
    } catch(erro) {
      this.erroBeneficiamento = this.textoErro(erro);
    } finally {
      this.estornandoBeneficiamento = false;
    }
  }

  classeVariacaoBeneficiamento(detalhe: any): string {
    if(!detalhe || detalhe.variacaoQuantidade === 0)
      return 'text-muted';
    return detalhe.variacaoQuantidade < 0 ? 'text-danger' : 'text-success';
  }

  private textoErro(erro: any): string {
    return typeof erro === 'string'
      ? erro
      : (erro && erro.message) || 'Não foi possível concluir a operação.';
  }

}
